import { createAction, handleActions } from 'redux-actions'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'project'

export const FETCH_PROJECT = createAction(`${BASE_ACTION_NAME}/index`)
export const FETCH_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/index/success`)
export const FETCH_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/index/failure`)

export const POST_PROJECT = createAction(`${BASE_ACTION_NAME}/post`)
export const POST_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/post/success`)
export const POST_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/post/failure`)

export const SHOW_PROJECT = createAction(`${BASE_ACTION_NAME}/show`)
export const SHOW_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/show/success`)
export const SHOW_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/show/failure`)

export const UPDATE_PROJECT = createAction(`${BASE_ACTION_NAME}/update`)
export const UPDATE_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/update/success`)
export const UPDATE_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/update/failure`)

export const DESTROY_PROJECT = createAction(`${BASE_ACTION_NAME}/destroy`)
export const DESTROY_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/destroy/success`)
export const DESTROY_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/destroy/failure`)

/////////////////
//// Reducer ////
/////////////////

export const initialState = {
  project: {
    id: 0,
    questions: []
  }
}

export default handleActions(
  {
    [FETCH_PROJECT_SUCCESS]: (state, { payload }) => ({
      ...state,
      project: payload.data
    }),

    [FETCH_PROJECT_FAILURE]: state => ({
      ...state
    })
  },
  initialState
)
